import Menu from '../config/app-menu';

// fallback in case a menu item has no `perm`
const permFromPath = (path = '') => {
  const first = String(path).split('/').filter(Boolean)[0] || 'dashboard';
  const alias = ({
    'order-details': 'orders',
    'hardware-profile': 'hardware',
    'profile': 'users',
    'ingredient': 'ingredients'  // legacy path fallback
  }[first] || first);
  return `${alias}:access`;
};

export default function findFirstAllowedPath(userPerms = [], isAdmin = false) {
  const has = (perm) => isAdmin || userPerms.includes(perm);

  const dfs = (items, inheritedPerm = null) => {
    for (const item of items) {
      if (item.is_header || item.is_divider) continue;

      const effectivePerm = item.perm || inheritedPerm || permFromPath(item.path);

      // If it's a group, only dive in when the group is allowed
      if (item.children?.length) {
        if (has(effectivePerm)) {
          const child = dfs(item.children, effectivePerm); // prefer first leaf
          if (child) return child;
          // if group has no children left, fall back to its own path
          if (item.path) return item.path;
        }
        continue;
      }

      // Leaf
      if (item.path && has(effectivePerm)) return item.path;
    }
    return null;
  };

  return dfs(Menu) || '/login';
}
